/**
 * Environment, validated once at module load.
 *
 * A missing variable fails loudly here rather than producing a Supabase client
 * pointed at `undefined`, which surfaces later as an unexplained network error
 * on the sign-in screen.
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(`${name} is not set. Copy app/.env.example to app/.env and fill it in.`)
  }
  return value.trim()
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  /**
   * The PUBLISHABLE key. Safe to ship in a bundle: `anon` is granted nothing on
   * this project — it sees no tables, not merely no rows. Never put the service
   * role key here; it belongs only in Edge Function secrets.
   */
  supabasePublishableKey: required(
    'VITE_SUPABASE_PUBLISHABLE_KEY',
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  ),
} as const

/** Base URL for Edge Functions on the linked project. */
export const functionsBase = `${env.supabaseUrl.replace(/\/+$/, '')}/functions/v1`
